import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  activeFilter,
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";

export type Building = {
  id: number;
  buildingNumber: string;
  siteId: string;
}

type ListBuildingsVariables = {
  siteId: string;
  nextToken?: string;
}

const listBuildings: Source<Building[], ListBuildingsVariables> = {
  graphql: parse(`
    query listBuildingBySiteIdAndBuildingNumber($nextToken: String, $siteId: String) {
      listBuildingBySiteIdAndBuildingNumber(
        limit: 10000,
        filter: { isActive: { eq: true } }
        nextToken: $nextToken
        siteId: $siteId
      ) {
        nextToken
        items {
          buildingNumber
          siteId
          id
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.BUILDINGS,
    index: "BuildingBySiteIdAndBuildingNumber",
    keyCondition: ({ siteId }) => ({
      expression: "#siteId = :siteId",
      names: { "#siteId": "siteId" },
      values: { ":siteId": siteId },
    }),
    filter: activeFilter,
  },
};

type GetBuildingVariables = {
  id: number;
}

const getBuildingSource: Source<Building, GetBuildingVariables> = {
  graphql: parse(`
    query getIRBuildingMaster($id: Int!) {
      getIRBuildingMaster(
        id: $id,
        modelName: "IRBuildingMaster"
      ) {
        id
        buildingNumber
        siteId
        isActive
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.GET,
    table: DynamoDbTables.BUILDINGS,
    key: ({ id }) => ({ modelName: "IRBuildingMaster", id }),
  },
};

export const getBuildings = async (client: SchemaClient, siteId: string): Promise<Building[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listBuildings, { siteId });
};

export const getBuilding = async (client: SchemaClient, id: number): Promise<Building | typeof EMPTY_VALUE> => {
  return (await client.query(getBuildingSource, { id }));
};

export const getAndProcessBuildings = async (client: SchemaClient, siteId: string): Promise<Building[]> => {
  const buildings = await getBuildings(client, siteId);
  return buildings?.map((building: Building) => ({
    id: building.id,
    buildingNumber: building.buildingNumber,
    siteId: building.siteId,
  })) ?? [];
};
